type LiveMethodologyMentorStatus = {
  showLiveStreamingWarning: boolean;
  showCloudRecordingError: boolean;
  hasIssue: boolean;
  isCompleted: boolean;
};

interface IParams {
  isRtAssistantEnabled?: boolean;
  hasZoomConnection: boolean;
  hasSupportedCloudRecordingConnection: boolean;
  isLiveStreamingEnabledForUser?: boolean;
  isAvBotSelected?: boolean;
}

export const getLiveMethodologyMentorStatus = ({
  isRtAssistantEnabled = true, // Defaults to enabled; override only when RT Assistant may be off
  hasZoomConnection,
  hasSupportedCloudRecordingConnection,
  isLiveStreamingEnabledForUser,
  isAvBotSelected
}: IParams): LiveMethodologyMentorStatus => {
  const isLiveStreamingDisabled = isLiveStreamingEnabledForUser !== true;
  const isAvBotDisabled = isAvBotSelected !== true;

  // Warning: Zoom connected, live streaming OFF, and Avoma bot not selected
  const showLiveStreamingWarning =
    isRtAssistantEnabled &&
    hasZoomConnection &&
    isLiveStreamingDisabled &&
    isAvBotDisabled;

  // Error: no Zoom connection but a supported cloud recording integration exists
  const showCloudRecordingError =
    isRtAssistantEnabled &&
    !hasZoomConnection &&
    hasSupportedCloudRecordingConnection;

  const hasIssue = showLiveStreamingWarning || showCloudRecordingError;

  return {
    showLiveStreamingWarning,
    showCloudRecordingError,
    hasIssue,
    isCompleted: !hasIssue
  };
};
